import { render, staticRenderFns } from "./McLanguage.html?vue&type=template&id=206bfec8&external"
import script from "./McLanguage.vue?vue&type=script&lang=js"
export * from "./McLanguage.vue?vue&type=script&lang=js"
import style0 from "./McLanguage.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports